export default __webpack_public_path__ + "static/media/market-sea.4dbbda1a.webp";